import { LocalApiService } from '../local-api/local-api.service';
import { map } from 'rxjs/operators';
var ImplPincodeService = /** @class */ (function () {
    function ImplPincodeService(localApiService) {
        this.localApiService = localApiService;
    }
    ImplPincodeService.prototype.verifyPin = function (pin) {
        return this.localApiService.verifyPin(pin).pipe(map(function (response) { return response.result === 'valid'; }));
    };
    ImplPincodeService.prototype.getRemainingAttempts = function () {
        return this.localApiService.getRemainingAttempts().pipe(map(function (response) { return response.count; }));
    };
    ImplPincodeService.prototype.getSuspensionExpiration = function () {
        var _this = this;
        return this.localApiService.getSuspensionExpiration().pipe(map(function (response) { return _this.millisToMinutes(response.result); }));
    };
    ImplPincodeService.prototype.millisToMinutes = function (millis) {
        var minutes = Math.round((millis - new Date().getTime()) / 1000 / 60);
        return minutes < 1 ? 1 : minutes;
    };
    return ImplPincodeService;
}());
export { ImplPincodeService };
